
export default {
  props: {
    type: {
      type: String,
      default: "",
    },
    uuid: {
      type: String,
      default: "",
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/profile_items/Mixin.js